import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "container",
  style: {"margin-top":"80px","padding-top":"40px"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { class: "text-dark" }
const _hoisted_5 = { style: {"font-size":"2em","font-weight":"300","color":"#33475b","margin":"0"} }
const _hoisted_6 = { class: "mb-0" }
const _hoisted_7 = { class: "col-lg-6 text-right mt-auto" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "container" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  class: "navbar navbar-light navbar-expand-md bg-light",
  role: "navigation"
}
const _hoisted_13 = { class: "form-inline mr-2" }
const _hoisted_14 = { class: "btn-group" }
const _hoisted_15 = { class: "dropdown-menu" }
const _hoisted_16 = { class: "form-inline mr-auto" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { class: "form-inline my-2 my-lg-0 mr-2" }
const _hoisted_19 = { class: "dropdown" }
const _hoisted_20 = {
  class: "text-primary font-weight-bold dropdown-toggle",
  "data-toggle": "dropdown"
}
const _hoisted_21 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  class: "form-inline my-2 my-lg-0",
  role: "search"
}
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col" }
const _hoisted_26 = { class: "table table-hover" }
const _hoisted_27 = {
  style: {"width":"40px"},
  class: "align-middle"
}
const _hoisted_28 = ["onUpdate:modelValue"]
const _hoisted_29 = { class: "fg-color-gray mb-0 mt-1" }
const _hoisted_30 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_31 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_32 = { class: "align-middle" }
const _hoisted_33 = {
  class: "progress",
  style: {"margin":"0"}
}
const _hoisted_34 = ["title"]
const _hoisted_35 = {
  key: 0,
  class: "align-middle"
}
const _hoisted_36 = ["onClick"]
const _hoisted_37 = {
  class: "align-middle",
  style: {"width":"120px"}
}
const _hoisted_38 = { class: "dropdown" }
const _hoisted_39 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_40 = {
  class: "dropdown-item",
  target: "_blank"
}
const _hoisted_41 = ["onClick"]
const _hoisted_42 = ["onClick"]
const _hoisted_43 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PanelistAlternativesSelector = _resolveComponent("PanelistAlternativesSelector")!
  const _component_PanelistsSelector = _resolveComponent("PanelistsSelector")!
  const _component_EmailSender = _resolveComponent("EmailSender")!
  const _component_SurveyAccessLinks = _resolveComponent("SurveyAccessLinks")!
  const _component_PortfolioOrDecisionNavigation = _resolveComponent("PortfolioOrDecisionNavigation")!
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.panelistAlternativesSelector)
      ? (_openBlock(), _createBlock(_component_PanelistAlternativesSelector, _mergeProps({ key: 0 }, _ctx.panelistAlternativesSelector, {
          onConfirm: _ctx.handleUpdatePanelistAlternativesCommand,
          onClose: _ctx.closePanelistAlternativesSelector
        }), null, 16 /* FULL_PROPS */, ["onConfirm", "onClose"]))
      : _createCommentVNode("v-if", true),
    (_ctx.panelistsSelector)
      ? (_openBlock(), _createBlock(_component_PanelistsSelector, _mergeProps({ key: 1 }, _ctx.panelistsSelector, {
          onShowPanelistAlternativesSelector: _ctx.showPanelistAlternativesSelector,
          onIncludePanelist: _ctx.handleIncludePanelistCommand,
          onExcludePanelist: _ctx.handleExcludePanelistCommand,
          onClose: _ctx.closePanelistsSelector
        }), null, 16 /* FULL_PROPS */, ["onShowPanelistAlternativesSelector", "onIncludePanelist", "onExcludePanelist", "onClose"]))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_EmailSender, {
      viewModel: _ctx.emailSender,
      onFormSubmit: _ctx.handleSendEmailCommand
    }, null, 8 /* PROPS */, ["viewModel", "onFormSubmit"]),
    _createVNode(_component_SurveyAccessLinks, {
      viewModel: _ctx.surveyAccessLinks,
      onSendEmail: _ctx.handleSendEmailCommand,
      onDownloadLinks: _ctx.downloadLinks
    }, null, 8 /* PROPS */, ["viewModel", "onSendEmail", "onDownloadLinks"]),
    _createVNode(_component_PortfolioOrDecisionNavigation, {
      workspaceId: _ctx.workspaceId,
      projectId: _ctx.projectId
    }, null, 8 /* PROPS */, ["workspaceId", "projectId"]),
    (_ctx.Initialized)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h6", null, [
                _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_4, [...(_cache[14] || (_cache[14] = [
                  _createElementVNode("i", {
                    class: "fa fa-angle-double-left",
                    "aria-hidden": "true"
                  }, null, -1 /* CACHED */),
                  _createTextVNode(" Back to panels ", -1 /* CACHED */)
                ]))])), [
                  [_directive_sanitizedHref, _ctx.url_AssessmentsPanelsPage]
                ])
              ]),
              _createElementVNode("h1", _hoisted_5, " Panelists: " + _toDisplayString(_ctx.SurveyName) + " (" + _toDisplayString(_ctx.Progress) + "%) ", 1 /* TEXT */),
              _createElementVNode("p", _hoisted_6, "Targeting: " + _toDisplayString(_ctx.TargetingLabel), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                role: "button",
                class: "btn btn-outline-secondary mr-1",
                style: {"padding":"0.7em 2em"},
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showAccessLinks && _ctx.showAccessLinks(...args)))
              }, "Access links"),
              _createElementVNode("button", {
                role: "button",
                class: "btn btn-success",
                style: {"padding":"0.7em 2em"},
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showPanelistsSelector && _ctx.showPanelistsSelector(...args))),
                disabled: !_ctx.EnabledAddingPanelists
              }, "Add panelists", 8 /* PROPS */, _hoisted_8)
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _cache[32] || (_cache[32] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 60px"} }, null, -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_9, [
      (!_ctx.Initialized)
        ? (_openBlock(), _createElementBlock("h3", _hoisted_10, [...(_cache[15] || (_cache[15] = [
            _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
            _createTextVNode(" Loading... ", -1 /* CACHED */)
          ]))]))
        : _createCommentVNode("v-if", true),
      (_ctx.Initialized)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("nav", _hoisted_12, [
              _createElementVNode("form", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  (_ctx.NonePanelistsSelected)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-outline-secondary btn-sm",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.SelectAllCommand && _ctx.SelectAllCommand(...args)))
                      }, [...(_cache[16] || (_cache[16] = [
                        _createElementVNode("i", { class: "fa-regular fa-square" }, null, -1 /* CACHED */)
                      ]))]))
                    : _createCommentVNode("v-if", true),
                  (_ctx.AnyPanelistsSelected && !_ctx.AllPanelistsSelected)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        class: "btn btn-outline-secondary btn-sm",
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.UnselectAllCommand && _ctx.UnselectAllCommand(...args)))
                      }, [...(_cache[17] || (_cache[17] = [
                        _createElementVNode("i", { class: "fa fa-minus-square" }, null, -1 /* CACHED */)
                      ]))]))
                    : _createCommentVNode("v-if", true),
                  (_ctx.AllPanelistsSelected)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        type: "button",
                        class: "btn btn-outline-secondary btn-sm",
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.UnselectAllCommand && _ctx.UnselectAllCommand(...args)))
                      }, [...(_cache[18] || (_cache[18] = [
                        _createElementVNode("i", { class: "fa-solid fa-square-check" }, null, -1 /* CACHED */)
                      ]))]))
                    : _createCommentVNode("v-if", true),
                  _cache[19] || (_cache[19] = _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-secondary btn-sm dropdown-toggle dropdown-toggle-split",
                    "data-toggle": "dropdown"
                  }, null, -1 /* CACHED */)),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("a", {
                      class: "dropdown-item",
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.SelectAllCommand && _ctx.SelectAllCommand(...args)))
                    }, "All"),
                    _createElementVNode("a", {
                      class: "dropdown-item",
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.UnselectAllCommand && _ctx.UnselectAllCommand(...args)))
                    }, "None"),
                    _createElementVNode("a", {
                      class: "dropdown-item",
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.InverseSelectionCommand && _ctx.InverseSelectionCommand(...args)))
                    }, "Inverse")
                  ])
                ])
              ]),
              _createElementVNode("form", _hoisted_16, [
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["btn btn-sm", [_ctx.NonePanelistsSelected ? 'btn-outline-secondary' : 'btn-outline-primary']]),
                  disabled: _ctx.NonePanelistsSelected,
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.EmailManyCommand && _ctx.EmailManyCommand(...args)))
                }, " Send email (" + _toDisplayString(_ctx.SelectedPanelistsCount) + ") ", 11 /* TEXT, CLASS, PROPS */, _hoisted_17)
              ]),
              _createElementVNode("form", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _cache[27] || (_cache[27] = _createTextVNode(" Filter: ", -1 /* CACHED */)),
                  _createElementVNode("a", _hoisted_20, _toDisplayString(_ctx.FilterLabel), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("a", {
                      class: "dropdown-item my-2",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.resetFilters()))
                    }, [...(_cache[20] || (_cache[20] = [
                      _createElementVNode("span", null, "All panelists", -1 /* CACHED */)
                    ]))]),
                    _cache[24] || (_cache[24] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                    _cache[25] || (_cache[25] = _createElementVNode("h6", { class: "dropdown-header" }, "By progress:", -1 /* CACHED */)),
                    _createElementVNode("a", {
                      class: "dropdown-item my-2",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.filterByProgress('Not started')))
                    }, [...(_cache[21] || (_cache[21] = [
                      _createElementVNode("span", null, "Not started", -1 /* CACHED */)
                    ]))]),
                    _createElementVNode("a", {
                      class: "dropdown-item my-2",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.filterByProgress('In progress')))
                    }, [...(_cache[22] || (_cache[22] = [
                      _createElementVNode("span", null, "In progress", -1 /* CACHED */)
                    ]))]),
                    _createElementVNode("a", {
                      class: "dropdown-item my-2",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.filterByProgress('Completed')))
                    }, [...(_cache[23] || (_cache[23] = [
                      _createElementVNode("span", null, "Completed", -1 /* CACHED */)
                    ]))]),
                    _cache[26] || (_cache[26] = _createElementVNode("h6", { class: "dropdown-header" }, "By tag:", -1 /* CACHED */)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags, (t) => {
                      return (_openBlock(), _createElementBlock("a", {
                        class: "dropdown-item",
                        onClick: ($event: any) => (_ctx.filterByTag(t))
                      }, _toDisplayString(t), 9 /* TEXT, PROPS */, _hoisted_22))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  ])
                ])
              ]),
              _createElementVNode("form", _hoisted_23, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-control form-control-sm mr-sm-2",
                  type: "search",
                  placeholder: "Search",
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.SearchPhrase) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.SearchPhrase]
                ])
              ])
            ]),
            _cache[31] || (_cache[31] = _createElementVNode("br", null, null, -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("table", _hoisted_26, [
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.PanelistsView, (p) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: p.ProjectUserId
                      }, [
                        _createElementVNode("td", _hoisted_27, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": ($event: any) => ((p.IsSelected) = $event),
                            style: {"width":"20px","height":"20px"}
                          }, null, 8 /* PROPS */, _hoisted_28), [
                            [_vModelCheckbox, p.IsSelected]
                          ])
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("p", _hoisted_29, [
                            _createElementVNode("span", null, _toDisplayString(p.Name), 1 /* TEXT */)
                          ]),
                          (p.HasEmail)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_30, _toDisplayString(p.Email), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true),
                          (!p.HasEmail)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_31, "Email not provided"))
                            : _createCommentVNode("v-if", true)
                        ]),
                        _createElementVNode("td", _hoisted_32, [
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("div", {
                              style: _normalizeStyle({ width: _ctx.getProgressStr(p.Progress) }),
                              title: _ctx.getProgressStr(p.Progress),
                              class: "progress-bar progress-bar-success progress-bar-striped",
                              role: "progressbar"
                            }, null, 12 /* STYLE, PROPS */, _hoisted_34)
                          ])
                        ]),
                        (_ctx.TargetingEnabled)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_35, [
                              _createElementVNode("a", {
                                onClick: ($event: any) => (_ctx.showPanelistAlternativesSelector(p.ProjectUserId)),
                                class: "text-primary"
                              }, _toDisplayString(p.AlternativesCount), 9 /* TEXT, PROPS */, _hoisted_36)
                            ]))
                          : _createCommentVNode("v-if", true),
                        _createElementVNode("td", _hoisted_37, [
                          _createElementVNode("div", _hoisted_38, [
                            _cache[30] || (_cache[30] = _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-outline-secondary dropdown-toggle",
                              "data-toggle": "dropdown"
                            }, " Actions ", -1 /* CACHED */)),
                            _createElementVNode("div", _hoisted_39, [
                              _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_40, [...(_cache[28] || (_cache[28] = [
                                _createTextVNode("Review", -1 /* CACHED */)
                              ]))])), [
                                [_directive_sanitizedHref, `/#/est/dashboard/${_ctx.workspaceId}/${_ctx.surveyId}/${p.ProjectUserId}`]
                              ]),
                              _createElementVNode("a", {
                                class: "dropdown-item",
                                onClick: ($event: any) => (_ctx.EmailOneCommand(p.ProjectUserId))
                              }, "Email", 8 /* PROPS */, _hoisted_41),
                              _cache[29] || (_cache[29] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                              (!_ctx.TargetingEnabled)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    class: "dropdown-item",
                                    onClick: ($event: any) => (_ctx.handleExcludePanelistCommand(p.ProjectUserId))
                                  }, "Exclude", 8 /* PROPS */, _hoisted_42))
                                : _createCommentVNode("v-if", true),
                              (_ctx.TargetingEnabled)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 1,
                                    class: "dropdown-item",
                                    onClick: ($event: any) => (_ctx.showPanelistAlternativesSelector(p.ProjectUserId))
                                  }, "Targeting", 8 /* PROPS */, _hoisted_43))
                                : _createCommentVNode("v-if", true)
                            ])
                          ])
                        ])
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}